__turbopack_context__.v({
  "autoRunToggle": "Calls-module__c2wCJW__autoRunToggle",
  "container": "Calls-module__c2wCJW__container",
  "empty": "Calls-module__c2wCJW__empty",
  "emptyFilter": "Calls-module__c2wCJW__emptyFilter",
  "emptyIcon": "Calls-module__c2wCJW__emptyIcon",
  "emptySubtitle": "Calls-module__c2wCJW__emptySubtitle",
  "emptyTexts": "Calls-module__c2wCJW__emptyTexts",
  "emptyTitle": "Calls-module__c2wCJW__emptyTitle",
  "fadeIn": "Calls-module__c2wCJW__fadeIn",
  "fetchingOverlay": "Calls-module__c2wCJW__fetchingOverlay",
  "footer": "Calls-module__c2wCJW__footer",
  "footerCount": "Calls-module__c2wCJW__footerCount",
  "header": "Calls-module__c2wCJW__header",
  "headerActions": "Calls-module__c2wCJW__headerActions",
  "item": "Calls-module__c2wCJW__item",
  "itemExcluded": "Calls-module__c2wCJW__itemExcluded",
  "itemFileName": "Calls-module__c2wCJW__itemFileName",
  "itemIcon": "Calls-module__c2wCJW__itemIcon",
  "itemMember": "Calls-module__c2wCJW__itemMember",
  "itemName": "Calls-module__c2wCJW__itemName",
  "itemSize": "Calls-module__c2wCJW__itemSize",
  "list": "Calls-module__c2wCJW__list",
  "listContainer": "Calls-module__c2wCJW__listContainer",
  "loaderContainer": "Calls-module__c2wCJW__loaderContainer",
  "loaderRow": "Calls-module__c2wCJW__loaderRow",
  "menuBtnContainer": "Calls-module__c2wCJW__menuBtnContainer",
  "noMember": "Calls-module__c2wCJW__noMember",
  "playBtnContainer": "Calls-module__c2wCJW__playBtnContainer",
  "readOnlyMember": "Calls-module__c2wCJW__readOnlyMember",
  "scrollWrapper": "Calls-module__c2wCJW__scrollWrapper",
  "tableHeader": "Calls-module__c2wCJW__tableHeader",
  "tableInner": "Calls-module__c2wCJW__tableInner",
  "title": "Calls-module__c2wCJW__title",
  "typeBadge": "Calls-module__c2wCJW__typeBadge",
  "typeClosing": "Calls-module__c2wCJW__typeClosing",
  "typeDemo": "Calls-module__c2wCJW__typeDemo",
  "typeDiscovery": "Calls-module__c2wCJW__typeDiscovery",
  "typeInterview": "Calls-module__c2wCJW__typeInterview",
  "typeOther": "Calls-module__c2wCJW__typeOther",
  "typeSelect": "Calls-module__c2wCJW__typeSelect",
});
